<template>
  <div class="wall-honor-index-container">
    <div class="title">
      荣誉证书
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/wallHonor' }"
            ><span class="dsadf"> 荣誉证书 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>比赛荣誉证书列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <div style="display: flex; flex-direction: column">
              <el-button type="primary" slot="trigger" size="small" @click="handleEdit({})">
                新增比赛荣誉
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table-control">
      <vxe-grid v-bind="gridOptions" @page-change="pageChangeEvent">
        <template #bgm_default="{ row }">
          <img :src="row.bgm" alt="" style="width: 100px" />
        </template>
        <template #demo_bgm_default="{ row }">
          <img :src="row.demo_bgm" alt="" style="width: 100px" />
        </template>
        <template #settings_default="{ row }">
          <el-button type="text" size="mini" @click="handleGoUsers(row)">
            用户列表
          </el-button>
        </template>
        <template #operation_default="{ row }">
          <el-button type="primary" size="mini" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import dayjs from "dayjs";
import { getWallHonorList, deleteWallHonor } from "@/api/honor";

export default {
  name: "WallHonorIndex",
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 10,
      },
      gridOptions: {
        showOverflow: false,
        border: true,
        loading: false,
        height: "auto",
        minHeight: "750px",
        pagerConfig: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        columns: [
          { field: "id", width: 70, title: "ID", align: "center" },
          { field: "title", minWidth: 240, title: "荣誉标题" },
          {
            field: "bgm",
            width: 120,
            title: "荣誉卡片",
            slots: { default: "bgm_default" },
          },
          {
            field: "demo_bgm",
            width: 120,
            title: "荣誉卡片默认图",
            slots: { default: "demo_bgm_default" },
          },
          { field: "created_at", width: 180, title: "创建时间" },
          {
            field: "settings",
            width: 150,
            title: "配置",
            fixed: "right",
            slots: { default: "settings_default" },
          },
          {
            field: "operation",
            width: 150,
            title: "操作",
            fixed: "right",
            slots: { default: "operation_default" },
          },
        ],
        data: [],
      },
    };
  },
  methods: {
    //  vxe分页变化
    pageChangeEvent(pageSize, currentPage) {
      this.tableParams.page = currentPage;
      this.tableParams.pageSize = pageSize;
      this.getWallHonorList();
    },
    getWallHonorList() {
      const postData = cloneDeep(this.tableParams);
      getWallHonorList(postData).then((res) => {
        if (res.data.result === 1) {
          const { list, total } = res.data.data;
          console.log("___getLotteryActivityList", list);
          this.gridOptions.data = list.map((item) => ({
            ...item,
            created_at: dayjs(item.created_at * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
          }));
          this.gridOptions.pagerConfig.total = total || list.length;
        }
      });
    },
    handleEdit(row) {
      this.$router.push(`/wallHonorEdit?id=${row.id}`);
    },
    handleGoUsers(row) {
      this.$router.push(`/wallHonorUsers?id=${row.id}`);
    },
    handleDelete(row) {
      this.$confirm(`确认删除【${row.title}】荣誉证书吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteWallHonor({ id: row.id }).then((res) => {
            if (res.data.result === 1) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getWallHonorList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    this.getWallHonorList();
  },
};
</script>

<style scoped lang="less">
.wall-honor-index-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  //   background: pink;
  .title {
    height: 60px;
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .table-control {
    height: calc(100% - 100px);
  }
}
</style>
